module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ranking-wraper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.load),
      expression: "load"
    }],
    staticClass: "loading-wrapper"
  }, [_c('loading')], 1), _vm._v(" "), _c('toplist', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "toplist",
    on: {
      "loadHide": function($event) {
        _vm.loadHide()
      }
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-965f9d42"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/ranking.vue
// module id = 212
// module chunks = 1